import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from "@/components/ui/dialog";
import { Separator } from "@/components/ui/separator";
import { collection, getDocs } from "firebase/firestore";
import { getDownloadURL } from "firebase/storage";
import { SetStateAction, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { db } from "../api/firebaseApi";
import { supportedExtensionsString } from "../constans";
import { getFileExtension } from "../helpers/file_helpers";
import { useAddFileToDB } from "../hooks/useAddFileToDB";
import { useGetFilesFromDB } from "../hooks/useGetFilesFromDB";
import { lawyerSelectors } from "../redux/lawyer/selectors";
import { ClientData, DATABASE } from "../types/tables-data";
import CustomSkeleton from "./common/CustomSkeleton";
import { DataTable } from "./DataTable";

export const LawFirmSettings = () => {
  const { id } = useParams();
  const lawyer = useSelector(lawyerSelectors.selectAll);
  const { onSubmitAddFile, fileRef, isLoadingAddFile } = useAddFileToDB();
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [data, setData] = useState<ClientData[] | null>(null);
  const { onSubmitGetFiles, storageFiles } = useGetFilesFromDB();
  const customersRef = collection(db, "/customers");
  const [isOpen, setIsOpen] = useState(false);
  const onOpen = () => setIsOpen(true);
  const onClose = () => setIsOpen(false);
  const [avatar, setAvatar] = useState("");
  const [firm, setFirm] = useState<ClientData | null>(null);
  const getImagesFromBD = async () => {
    try {
      await onSubmitGetFiles(`${DATABASE.FIRMS}/avatars/${firm?.practiceName}`);
    } catch (e) {
      //   console.log(e);
      //   dispatch(updateLawyerAvatar({ avatarSrc: "/", avatarName: "" }));
    }
  };
  const uploadImage = async () => {
    if (selectedFile) {
      const extension = getFileExtension(selectedFile);
      try {
        await onSubmitAddFile(
          selectedFile,
          `${DATABASE.FIRMS}/avatars/${firm?.practiceName}/logo${extension}`,
          true
        );
        setSelectedFile(null);
        getImagesFromBD();
      } catch (e) {
        Sentry.captureException(e);
      }
    }
  };

  useEffect(() => {
    const fetchDataAndImages = async () => {
      // Fetch customers
      const data = await getDocs(customersRef);
      if (data.docs) {
        const docs: SetStateAction<ClientData[]> = [];
        data.forEach((doc) => {
          docs.push(doc.data() as ClientData);
        });
        if (docs) setData(docs);
      }

      // Upload image if selected
      if (selectedFile) {
        await uploadImage();
      }

      // Fetch images from DB when the modal opens
      if (isOpen) {
        await getImagesFromBD();
      }

      // Set avatar when storage files change
      if (storageFiles.length !== 0) {
        const file = storageFiles[0];
        const url = await getDownloadURL(file);
        setAvatar(url);
      }
    };

    fetchDataAndImages();
  }, [selectedFile, isOpen, storageFiles]);
  return (
    <div className="pt-4">
      {/* <div className="relative rounded shadow-sm mb-4 ">
        <Image className="w-full h-28 object-fil " src={images.joinPageWawes} />
      </div> */}
      <Separator className="my-4" />
      {data && (
        <DataTable
          data={data}
          columns={[
            { accessorKey: "email" },
            { accessorKey: "practiceName" },
            {
              accessorKey: "created_at",
              accessorFn: (row) => new Date(row.created_at!)
            },
            {
              accessorKey: "actions",
              cell: (value) => (
                <p
                  onClick={() => {
                    setFirm(value.row.original);
                    onOpen();
                  }}
                >
                  Edit
                </p>
              )
            }
          ]}
          sortBy="created_at"
        />
      )}
      <Dialog
        open={isOpen}
        onOpenChange={(open) => {
          if (!open) onClose();
        }}
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Law Firm Edit</DialogTitle>
          </DialogHeader>
          {/* <DataTable/> */}
          <div className="flex items-center gap-8">
            <span className="text-base font-medium text-fg">
              Law Firm Logo:
            </span>
            <div className="relative flex flex-col items-center justify-center gap-8">
              <img
                src={avatar}
                alt=""
                onClick={() => {
                  fileRef.current?.click();
                }}
                className="relative max-h-24 max-w-48 cursor-pointer bg-cover"
              />

              {isLoadingAddFile && <CustomSkeleton variant="avatar" />}

              {/* <Text color="primary.darkBlue" className="font-medium text-xl">
            {lawyer.practiceName}
          </Text>
          <Text className="text-xs">Account type: Lawyer</Text> */}
            </div>

            <input
              type="file"
              ref={fileRef}
              onChange={(e) => {
                if (e.target.files) {
                  setSelectedFile(e.target.files[0]);
                }
              }}
              accept={supportedExtensionsString}
              className="sr-only"
            />
          </div>
          <Separator />
          <span className="text-base font-medium text-fg">
            Law Firm Name : {firm?.practiceName}
          </span>

          <DialogFooter>
            <Button variant="secondary" onClick={onClose}>
              Close
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};
